import type { ColumnFilter, Row } from "@tanstack/react-table";
import type { TFunction } from "i18next";

import { Button, Confirm } from "src/components";
import { Color } from "src/theme";
import type { CustomerActionRequestDto, CustomerDebtListDto } from "src/types";
import { getParamsForBlockUnblockTables } from "../../utils";

export const createActionsForSelection =
    (t: TFunction, blockPayersMutation: (value: CustomerActionRequestDto) => void) =>
    (isAllRowsSelected: boolean, selectedRows: CustomerDebtListDto[], filters: ColumnFilter[]) => {
        const selectedRowIds = selectedRows.map((row) => row.id);
        const onClick = () => {
            blockPayersMutation(getParamsForBlockUnblockTables(isAllRowsSelected, selectedRowIds, filters));
        };
        return (
            <Confirm title={t("customers.block.confirm.title")} content={t("customers.block.confirm.content")} onConfirm={onClick}>
                {(open) => (
                    <Button disabled={!isAllRowsSelected && selectedRows.length === 0} type="button" onClick={open}>
                        {t("customers.block.blockSelected")}
                    </Button>
                )}
            </Confirm>
        );
    };

export const overrideRowProps = (row: Row<CustomerDebtListDto>): Record<string, unknown> => {
    if (row.original.branches.some((branch) => branch.isHospital)) {
        return { $backgroundColor: Color.primary100 };
    }

    return { $backgroundColor: Color.white };
};
